export const menuItems = [
    {
        id: 1,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/"
    },
    {
        id: 2,
        isLayout: true
    },
    {
        id: 3,
        label: "menuitems.generaloperation.text",
        isTitle: true
    },
    {
        id: 4,
        label: "menuitems.customer.text",
        icon: "bx-user",
        link: "/general/customer"
    },
    {
        id: 5,
        label: "menuitems.seller.text",
        icon: "bx bx-user-circle",
        subItems: [{
            id: 35,
            label: "menuitems.seller.staff",
            icon: "bx bx-user-circle",
            link: "/general/seller/staff"
        }, {
            id: 36,
            label: "menuitems.seller.agency",
            icon: "bx bx-user-circle",
            link: "/general/seller/agency"
        }, {
            id: 37,
            label: "menuitems.seller.mentor",
            icon: "bx bx-user-circle",
            link: "/general/seller/mentor"
        }]
    },
    {
        id: 32,
        label: "menuitems.property.text",
        icon: "bx-building",
        subItems: [
            {
                id: 6,
                label: "menuitems.property.text",
                icon: "bx-building",
                link: "/general/property"
            },
            {
                id: 30,
                label: "menuitems.cancelation.text",
                icon: "bx-folder-minus",
                link: "/general/cancelation/"
            },
            {
                id: 19,
                label: "menuitems.additionaloperation.list.viewmap.text",
                link: "/additional/view-map",
                icon: "bx-chat"
            },
            {
                id: 20,
                label: "menuitems.additionaloperation.list.propertymaster.text",
                link: "/additional/property-master",
                icon: "bx-chat"
            },
            {
                id: 21,
                label: "menuitems.additionaloperation.list.buyback.text",
                link: "/additional/buy-back",
                icon: "bx-chat"
            },
            {
                id: 31,
                label: "menuitems.additionaloperation.list.handover.text",
                link: "/additional/handover",
                icon: "bx-chat"
            },
            {
                id: 39,
                label: "menuitems.additionaloperation.list.payoff-handover.text",
                link: "/additional/payoff-handover",
                icon: "bx-chat"
            }
        ]
    },
    {
        id: 33,
        label: "menuitems.booking.text",
        icon: "bx-bookmark",
        subItems: [
        {
            id: 7,
            label: "menuitems.booking.text",
            icon: "bx-bookmark",
            link: "/general/booking"
        }, {
            id: 25,
            label: "menuitems.additionaloperation.list.returndeposit.text",
            link: "/additional/return-deposit",
            icon: "bx-chat"
        }]
    },
    {
        id: 34,
        label: "menuitems.sale.text",
        icon: "bx-dollar-circle",
        subItems: [{
            id: 8,
            label: "menuitems.sale.text",
            icon: "bx-dollar-circle",
            link: "/general/sale"
        
        }, {
            id: 38,
            label: "sale.transfer-to-other",
            icon: "bx-dollar-circle",
            link: "/general/sale/transferlist"
        }, {
            id: 26,
            label: "menuitems.additionaloperation.list.commission.text",
            link: "/additional/commission",
            icon: "bx-chat"
        }]
    },
    
    // { 
    //     id: 9,
    //     label: "menuitems.loan.text",
    //     icon: "bx bx-wallet",
    //     link: "/general/loan"
    // },
    // {
    //     id: 10,
    //     label: "menuitems.payment.text",
    //     icon: "bx-money",
    //     link: "/general/payment"
    // },
    {
        id: 11,
        label: "menuitems.otheroperation.text",
        isTitle: true
    },
    {
        id: 12,
        label: "menuitems.profitlost.text",
        icon: "bx-repost",
        subItems: [

            {
                id: 14,
                label: "menuitems.profitlost.list.income",
                link: "/finance/income",
                parentId: 10
            },
            {
                id: 15,
                label: "menuitems.profitlost.list.expense",
                link: "/finance/expense",
                parentId: 10
            },
            {
                id: 16,
                label: "menuitems.profitlost.list.history",
                link: "/finance/history",
                parentId: 10
            },

            {
                id: 22,
                label: "stock-owner.text",
                link: "/finance/stock",
                parentId: 10
            },
            // {
            //     id: 33,
            //     label: "accounting.journal",
            //     link: "/finance/journal",
            //     parentId: 10
            // },
            
        ] 
    },
    {
        id: 17,
        label: "menuitems.additionaloperation.text",
        icon: "bx-grid-small",
        subItems: [
            // {
            //     id: 18,
            //     label: "menuitems.additionaloperation.list.loancal.text",
            //     link: "/additional/loan-calculator",
            //     icon: "bx-chat"
            // },
            
            // {
            //     id: 22,
            //     label: "menuitems.additionaloperation.list.saleperson.text",
            //     link: "/additional/sale-person",
            //     icon: "bx-chat"
            // },
            {
                id: 23,
                label: "menuitems.additionaloperation.list.supplier.text",
                link: "/additional/supplier",
                icon: "bx-chat"
            },
            {
                id: 30,
                label: "menuitems.additionaloperation.list.category.text",
                link: "/additional/category",
                icon: "bx-chat"
            },
            {
                id: 31,
                label: "menuitems.additionaloperation.list.item.text",
                link: "/additional/item",
                icon: "bx-chat"
            },
            {
                id: 32,
                label: "menuitems.additionaloperation.list.invoice.text",
                link: "/additional/invoice",
                icon: "bx-chat"
            },
            // {
            //     id: 24,
            //     label: "menuitems.additionaloperation.list.writeoff.text",
            //     link: "/additional/write-off",
            //     icon: "bx-chat"
            // },
            
            
            
            // {
            //     id: 27,
            //     label: "menuitems.additionaloperation.list.blockproperty.text",
            //     link: "/additional/block-property",
            //     icon: "bx-chat"
            // },
        ]
    },

    {
        id: 28,
        label: "setting.text",
        icon: "bx-wrench",
        link: "/setting"
    },
    
    {
        id: 29,
        label: "menuitems.report.text",
        icon: "bx-file",
        link: "/report"
    },

    
    
];
